<template>
	<div class="content">
		<div class="row" v-if="alertShow === true || asyncDone === false">
			<div class="col-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
				</div>
			</div>
		</div>
		<div class="row" v-if="asyncDone">
			<div class="col-12">
				<div class="card">
					<div class="card-header">
						<h4 class="card-title d-inline-block">Migrations</h4>
						<router-link v-if="accountsOrdered.length > 0" :to="{ name: 'requestMigration' }" class="btn btn-primary btn-round d-inline-block float-right">
							<i class="fa fa-database"></i> New Migration Request
						</router-link>
						<router-link v-else :to="{ name: 'addSite', query: {toMigrate: 0} }" class="btn btn-primary btn-round d-inline-block float-right">
							<i class="fa fa-database"></i> New Migration Request
						</router-link>
					</div>
					<div class="card-body">
						<MigrationLog />
					</div>
				</div>
				<router-link v-if="accountsOrdered.length > 0" :to="{ name: 'requestMigration' }" class="btn btn-primary btn-lg w-100">
					<i class="fa fa-database"></i> New Migration Request
				</router-link>
				<router-link v-else :to="{ name: 'addSite', query: {toMigrate: 0} }" class="btn btn-primary btn-lg w-100">
					<i class="fa fa-database"></i> New Migration Request
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "migrationLogPage",
	components: {
    Alert: () =>
      import(/* webpackChunkName: "alert" */ "../../../../components/Alerts.vue"),
    MigrationLog: () =>
      import(/* webpackChunkName: "siteList" */ "../../../../components/User/Migration/MigrationLog/MigrationLog.vue")
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    alertType() {
      return this.$store.getters["alert/type"];
    },
    alertMessage() {
      return this.$store.getters["alert/message"];
    },
    alertShow() {
      return this.$store.getters["alert/show"];
    },
	accountsOrdered() {
		return this.$store.getters["hosting/accountsOrdered"];
	},
  }
}
</script>
